import { Component, OnInit } from '@angular/core';
import { Select2Option } from '../shared/select2-option';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UserService } from '../users/services/user.service';
import { UserDetailService } from '../users/services/user-detail.service';

@Component({
    selector: 're-test',
    templateUrl: './test.component.html',
    styleUrl: './test.component.scss',
    standalone: false
})
export class TestComponent implements OnInit {

  testForm: UntypedFormGroup;
 
  constructor(private fb: UntypedFormBuilder, private svc: UserDetailService) {
    this.testForm = this.fb.group({
      testId: [''],
    });
  }
  statusFilterOptions: string[] = ['All', 'Active'];
  selectedStatusFilter = '';
  statusDropdownOptions: Select2Option[] = this.statusFilterOptions.map(x => { return { id: x, text: x } });

  ngOnInit(): void {
    setTimeout(() => {

      this.items = ["aa"];
    }, 2000);
    //this.loadData();
  }
  options: Select2Option[];
  options2: Select2Option[];
  options3: Select2Option[];

  loadData() {
    this.options = [
      { id: "1", text: "Text 1" },
      { id: "2", text: "Text 2" },
      { id: "3", text: "Text 3", disabled: true },
      { id: "4", text: "Text 4" },
    ];

    this.options2 = JSON.parse(JSON.stringify(this.options));
    this.svc.addDefaultOption(this.options2);
    this.selectedValue2 = "2";
 

  }

  clearData() {
    this.options = [];
  }
  onSelect($event) {
    console.log("onselect", $event);
    //this.log = $event;
  }

  viewValues() {
    console.log(this.selectedValue);
  }
  setValue(val) {
    this.selectedValue = val;
  }
  log = "";
  items = [];
  selectedValue: string = null;
  selectedValue2: string = null;
  selectedValue3: string = "";
  disabled = true;
  disabledReactive = this.disabled;

  disableToggle() {
    this.disabled = !this.disabled;
    this.disabledReactive = !this.disabledReactive;
  }

  disableToggleReactive() {
    this.disabledReactive = !this.disabledReactive;
    if (this.disabledReactive)
      this.testForm.get("testId").disable();
    else
      this.testForm.get("testId").enable();
  }
}
